module.exports = __webpack_public_path__ + "static/media/Forest Elf.83519a2b.jpg";